import React from 'react';
import './Banner.css';

import { Heading, Button } from '../../components'; // Importing reusable Heading and Button components

const Banner = ({ title, subTitle, buttonText1, buttonLink1, buttonText2, buttonLink2 }) => {
  return (
    <section className="banner">
      <div className="content">
        
        {/* Heading component with dynamic props */}
        <Heading title={title} subTitle={subTitle} linear />
        
        <div className='buttons'>
          <Button link={buttonLink1} title={buttonText1} /> {/* Primary button with dynamic text and link */}
          {buttonText2 && buttonLink2 && <Button link={buttonLink2} title={buttonText2} />} {/* Conditionally render the second button if text and link exist */}
        </div>

      </div>
    </section>
  );
};

export default Banner;